var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_vm._m(0),_c('div',{ref:"linechart",staticClass:"linechart"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-left"},[_c('div',{staticClass:"bg1"})])
}]

export { render, staticRenderFns }